<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:08:56
 * @name: 商品管理
 * @Description: 商品管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\goodsManage\waresGoodsManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <table-search-form title="产品列表">
      <template v-slot:searchForm>
        <div class="search-form">
          <div class="search-line">
            <div class="search-label"><font>搜索</font></div>
            <div class="search-content">
              <el-input
                size="mini"
                v-model="searchForm.goods_name"
                placeholder="请输入产品名称"
                @blur="setFocus()"
                @keyup.native.enter="onQuery"
              ></el-input>
            </div>
          </div>
          <div class="search-line">
            <div class="search-label"><font>型号</font></div>
            <div class="search-content">
              <div
                class="search-checkbox-group"
                :class="{ showLess: !modelMore }"
              >
                <el-radio-group
                  size="mini"
                  v-model="searchForm.category_id"
                  @change="setFocus()"
                >
                  <el-radio-button :label="0">全部</el-radio-button>
                  <el-radio-button
                    v-for="item of modelGoods.options_model"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.category_name }}
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="search-more" @click="modelMore = !modelMore">
                <font>{{ modelMore ? "收起" : "更多" }}</font
                ><i :class="'el-icon-arrow-' + (modelMore ? 'up' : 'down')"></i>
              </div>
            </div>
          </div>
          <div class="search-line">
            <div class="search-label"><font>颜色</font></div>
            <div class="search-content">
              <div
                class="search-checkbox-group"
                :class="{ showLess: !colorMore }"
              >
                <el-radio-group
                  size="mini"
                  v-model="searchForm.color_id"
                  @change="setFocus()"
                >
                  <el-radio-button :label="0">全部</el-radio-button>
                  <el-radio-button
                    v-for="item of waresGoods.options_color"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.color }}
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="search-more" @click="colorMore = !colorMore">
                <font>{{ colorMore ? "收起" : "更多" }}</font
                ><i :class="'el-icon-arrow-' + (colorMore ? 'up' : 'down')"></i>
              </div>
            </div>
          </div>
          <div class="search-line">
            <div class="search-label"><font>状态</font></div>
            <div class="search-content">
              <div class="search-checkbox-group">
                <el-radio-group
                  size="mini"
                  v-model="searchForm.status"
                  @change="setFocus()"
                >
                  <el-radio-button
                    v-for="item of statusList"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.value }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="btn-group">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="primary"
              id="filterSearch"
              @keyup.enter="onQuery"
              @click="onQuery"
              >搜索</el-button
            >
            <el-button
              size="mini"
              icon="el-icon-refresh"
              plain
              @click="initData()"
              >刷新</el-button
            >
          </div>
        </div>
      </template>
      <template v-slot:head>
        <div class="head">
          <el-button size="mini" plain @click="addProduct">添加产品</el-button>
        </div>
      </template>
      <template v-slot:table>
        <el-table
          :data="waresGoods.table_wares_data.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column
            align="center"
            prop="id"
            label="ID"
            width="100"
          ></el-table-column>
          <el-table-column align="center" label="产品图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.upload ? scope.row.upload.file_url_path : ''"
                @click="
                  showImage(
                    scope.row.upload ? scope.row.upload.file_url_path : ''
                  )
                "
              />
            </template>
          </el-table-column>
          <el-table-column align="center" prop="goods_name" label="产品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="category.category_name"
            label="型号"
          >
          </el-table-column>
          <el-table-column align="center" prop="color.color" label="颜色">
          </el-table-column>
          <el-table-column type="expand" label="价格">
            <template slot-scope="props">
              <el-table
                size="mini"
                :data="props.row.goods_level"
                tooltip-effect="light"
                fit
                :header-cell-style="{
                  'background-color': $scssVars['Vars-background-bar-normal'],
                  color: '#666',
                }"
                style="width: calc(100% - 180px)"
                :style="{
                  fontSize: $scssVars['Vars-font-miniContent-size'],
                }"
              >
                <el-table-column
                  align="center"
                  prop="level"
                  label="级别"
                  width="100"
                >
                </el-table-column>
                <el-table-column align="center" prop="price" label="价格">
                </el-table-column>
                <el-table-column align="center" label="琴行">
                  <template slot-scope="scope">
                    <font>{{ scope.row | agencyNameFilter }}</font>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  fixed="right"
                  label="操作"
                  width="180"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="showAllPianoCompany(props.row, scope.row)"
                      >全部琴行</el-button
                    >
                    <font class="clip">|</font>
                    <el-button
                      size="mini"
                      type="text"
                      @click="addPianoCompany(props.row, scope.row)"
                      >添加琴行</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                :value="scope.row.status"
                @change="statusChange($event, scope.row)"
                active-color="#13ce66"
                :inactive-color="$scssVars['Vars-font-placeholder-color']"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="editProduct(scope.row)"
                >编辑</el-button
              ><font class="clip">|</font>
              <el-button size="mini" type="text" @click="del(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="waresGoods.table_wares_data.total"
        >
        </Pagination>
      </template>
    </table-search-form>
    <addNedit-product
      ref="addNeditProduct"
      :modelGoods="modelGoods"
      :waresGoods="waresGoods"
      @edit="editProductHandler"
      @add="addProductHandler"
    ></addNedit-product>
    <all-piano-company
      ref="allPianoCompany"
      :waresGoods="waresGoods"
      @editAllPianoCompanyHandler="editAllPianoCompanyHandler"
    ></all-piano-company>
    <add-piano-company
      ref="addPianoCompany"
      :waresGoods="waresGoods"
      @editAllPianoCompanyHandler="editAllPianoCompanyHandler"
    ></add-piano-company>
    <big-image ref="bigImage"></big-image>
  </layout-normal>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import modelGoods from "@/object/goods/modelGoods.class.js";
import waresGoods from "@/object/goods/waresGoods.class.js";
import allPianoCompany from "@/components/waresGoodsManage/dialog/all-piano-company.vue";
import addPianoCompany from "@/components/waresGoodsManage/dialog/add-piano-company.vue";
import addNeditProduct from "@/components/waresGoodsManage/dialog/addNedit-product.vue";
import bigImage from "@/components/public/big-image.vue";
import { confirmation, debounceation } from "@/utils/decorator";

export default {
  name: "waresGoodsManage",
  components: {
    tableSearchForm,
    allPianoCompany,
    addPianoCompany,
    addNeditProduct,
    bigImage,
  },
  data() {
    return {
      modelGoods: new modelGoods(), //品牌系列型号对象
      waresGoods: new waresGoods(), //商品对象
      loading: false, //表格加载状态
      searchForm: {}, //搜索条件
      modelMore: false, //型号展示更多
      colorMore: false, //颜色展示更多
      statusList: [
        //状态数组
        {
          id: 2,
          value: "全部",
        },
        {
          id: 1,
          value: "显示",
        },
        {
          id: 0,
          value: "隐藏",
        },
      ],
      pagination: {}, //分页器信息
    };
  },
  watch: {
    //分页数据发送变化查询表格数据
    pagination: {
      handler(nv, ov) {
        nv.page && this.getTableData();
      },
      immediate: false,
      deep: true,
    },
  },
  filters: {
    agencyNameFilter(e) {
      let fontList = [];
      fontList = e?.agency_goods_in?.map((x) => x.agency.agency_name) ?? [];
      if (fontList.length > 3) {
        return (fontList.slice(0, 3)?.join("、") ?? "") + "...";
      } else {
        return fontList.slice(0, 3)?.join("、") ?? "";
      }
    },
  },
  activated() {
    this.initData(); //初始化数据
    this.refresh();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 刷新页面
     */
    refresh() {
      this.getOptionsModel(); //获取型号数组
      this.getOptionsColor(); //获取颜色数组
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化数据
     */
    @debounceation(300)
    initData() {
      this.initSearchForm(); //初始化搜索条件表单
      this.searchForm.category_id = this.$route.params?.category_id ?? 0; //router params传参有型号字段,放入查询参数
      this.$delete(this.$route.params, "category_id"); //清除 router params字段(刷新时不在使用该参数)
      this.initPagination(); //初始化分页信息
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取型号数组
     */
    getOptionsModel() {
      this.modelGoods.getOptionsModel().then((res) => {
        this.$route.query?.model_id &&
          (this.searchForm.model = [Number(this.$route.query?.model_id)]);
      }); //调用modelGoods对象方法
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取颜色数组
     */
    getOptionsColor() {
      this.waresGoods.getOptionsColor(); //调用waresGoods对象方法
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化搜索条件表单
     */
    initSearchForm() {
      this.searchForm = {
        goods_name: "",
        category_id: 0,
        color_id: 0,
        status: 2,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化分页信息
     */
    initPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加产品
     */
    @debounceation(300)
    addProduct() {
      this.$refs.addNeditProduct.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加产品弹窗回调
     * @param {Object} form 表单信息
     */
    addProductHandler(form) {
      this.waresGoods.addProduct(form).then((res) => {
        this.getTableData();
        this.$refs.addNeditProduct.cancel(); //关闭弹窗
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑产品
     * @param {Object} row 表格行数据
     */
    @debounceation(300)
    editProduct(row) {
      let form = JSON.parse(JSON.stringify(row));
      form.file_id = form.upload.file_id;
      form.image = form.upload?.file_url_path ?? "";
      form.goods_level = form.goods_level.map((x) => {
        return {
          level: x.level,
          price: x.price,
        };
      });
      this.$refs.addNeditProduct.open(form);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑产品弹窗回调
     * @param {Object} form 表单信息
     */
    editProductHandler(form) {
      this.waresGoods.editProduct(form).then((res) => {
        this.getTableData();
        this.$refs.addNeditProduct.cancel(); //关闭弹窗
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除商品
     * @param {Object} row 表格行数据
     */
    @confirmation(
      (row) =>
        `确认删除名为${row.goods_name},型号为${row.category.category_name},颜色为${row.color.color}的产品?`
    )
    del(row) {
      this.waresGoods.deleteItem({ goods_id: row.id }).then((res) => {
        this.getTableData();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 产品状态变更
     * @param {Boolean} e 变更状态
     * @param {Object} row 表格行数据
     */
    @debounceation(300)
    statusChange(e, row) {
      this.waresGoods.statusChange({ goods_id: row.id, status: e });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 全部琴行
     * @param {Object} row 产品行数据
     * @param {Object} childRow 级别行数据
     */
    showAllPianoCompany(row, childRow) {
      this.$refs.allPianoCompany.open(childRow);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加琴行
     * @param {Object} row 产品行数据
     * @param {Object} childRow 级别行数据
     */
    addPianoCompany(row, childRow) {
      this.$refs.addPianoCompany.open(childRow);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 置焦点于搜索框
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击搜索框
     */
    @debounceation(300)
    onQuery() {
      this.initPagination();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTableData() {
      let params = { ...this.searchForm, ...this.pagination };
      params.goods_name || this.$delete(params, "goods_name");
      params.category_id === 0 && this.$delete(params, "category_id");
      params.color_id === 0 && this.$delete(params, "color_id");
      params.status === 2 && this.$delete(params, "status");
      this.loading = true;
      this.waresGoods.getTableData(params).finally(() => {
        this.loading = false;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 查看大图
     * @param {String} url 图片路径
     */
    @debounceation(300)
    showImage(url) {
      this.$refs.bigImage.open(url);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 产品级别添加或删除琴行回调刷新表格数据
     */
    editAllPianoCompanyHandler() {
      this.getTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-table {
  width: 100%;
  img {
    display: block;
    width: $Var-table-image-size;
    margin: 0 auto;
    @extend .extend-clickElement;
  }
  .el-button {
    margin: 0;
    padding: 0 6px;
  }
  .clip {
    color: $Vars-font-placeholder-color;
  }
  /deep/ .el-switch__core:before {
    content: "隐";
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 21px;
  }
  /deep/.is-checked .el-switch__core:before {
    content: "显" !important;
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 5px;
  }
  /deep/ .el-table__expand-icon {
    .el-icon {
      margin-left: 0;
      margin-top: 0;
      transform: translate(-50%, -50%);
    }
  }
  /deep/ .el-icon-arrow-right:before {
    content: "\e78f";
    font-size: 18px;
  }
  /deep/ .el-table__expand-icon--expanded {
    transform: rotate(180deg);
  }
  /deep/ .el-table__fixed-right::before,
  .el-table__fixed::before {
    height: 0 !important;
  }
}
</style>